import { TextWithDropShadow } from '../TextWithDropShadow';

export interface StrapiPillCalloutData {
  content: {
    text: string;
    shadow: boolean;
    hidden: boolean;
    size: {
      size: string;
    };
    color: {
      color: string;
    };
  };
  contentAlignment: string;
  calloutBGColor: string;
  padding: {
    top: string;
    right: string;
    bottom: string;
    left: string;
  };
}

export default function PillCallout({ data }: { data: StrapiPillCalloutData }) {
  const paddingClass =
    data.padding &&
    `p-0 pt-${data.padding.top} md:pr-${data.padding.right} pb-${data.padding.bottom} md:pl-${data.padding.left} `;
  return (
    <div className={`${paddingClass} flex justify-center`}>
      <div
        className={`text-base font-medium ${data.contentAlignment} bg-[${data.calloutBGColor}] w-full rounded-2xl p-8 md:rounded-full md:px-8 md:py-4 lg:max-w-6xl`}
      >
        <TextWithDropShadow
          text={data.content?.text}
          color={{
            text: data.content?.color?.color || 'text-grey-900',
            shadow: '',
          }}
          displayShadow={false}
        />
      </div>
    </div>
  );
}
